<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="3"><h5>Choose country type</h5> </CCol>
            <CCol sm="2"
              ><input
                type="radio"
                v-model="countrymodel"
                value="allcountry"
              />&nbsp;<span style="font-size: large">All country</span>
            </CCol>
            <CCol sm="3"
              ><input
                type="radio"
                v-model="countrymodel"
                value="particularcountry"
              />&nbsp;<span style="font-size: large">Particular country</span>
            </CCol>
            <CCol sm="2"> </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody v-if="allcon">
          <CInput
            label="Total supply"
            placeholder="Enter Total supply"
            v-model="token.supply"
            type="number"
          />
        </CCardBody>
        <CCardBody v-if="partcon">
          <CRow>
            <CCol sm="12">
              <span style="font-size: 14px">Country *</span>
              <br />

              <br />

              <div
                class="form-group"
                v-for="(input, k) in this.token.country"
                :key="k"
              >
                <CRow>
                  <CCol sm="6">
                    <Vselect
                      v-model="input.name"
                      :options="companyCountry"
                      searchable
                    ></Vselect>
                  </CCol>
                  <CCol sm="4">
                    <input
                      type="number"
                      class="form-control"
                      v-model="input.tokenAmount"
                    />
                  </CCol>
                  <CCol sm="2">
                    <span>
                      <CButton
                        color="danger"
                        @click="remove(k)"
                        v-show="k || (!k && token.country.length > 1)"
                      >
                        <i class="fa fa-times"></i></CButton
                      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <CButton
                        color="success"
                        @click="add(k)"
                        v-show="k == token.country.length - 1"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i
                      ></CButton>
                    </span>
                  </CCol>
                </CRow>
              </div>
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>

    <CCol sm="12">
      <span style="font-size: 14px">Location</span>
      <br />
      <multiselect
        v-model="token.location"
        :options="this.multiselectOptions"
        :multiple="true"
      />
    </CCol>
    <br />
    <br />

    <CCol sm="6" style="margin-top: 30px">
      <CCard>
        <CCardHeader>
          <span style="font-size: 14px; font-weight: bold"
            >Whitelist (CSV file to import)</span
          >

          <input
            type="checkbox"
            value="test"
            v-model="csvSelected"
            style="float: right; width: 113px; height: 22px"
          />
        </CCardHeader>
        <CCardBody v-if="whitehide">
          <CAlert
            :show.sync="dismissCountDown"
            v-if="showAlert"
            closeButton
            color="success"
            fade
          >
            Data uploaded
            <!-- <strong>{{dismissCountDown}}</strong> seconds... -->
          </CAlert>
          <span style="color: red">Please upload .CSV file</span><br />
          <input
            id="fileInput"
            type="file"
            @change="upload"
            accept=".csv"
            ref="input"
          />
        </CCardBody>
      </CCard>
    </CCol>

    <CCol sm="6" style="margin-top: 30px">
      <CCard>
        <CCardHeader>
          <span style="font-size: 14px; font-weight: bold"
            >Token promo GIF / Video</span
          >

          <input
            type="checkbox"
            value="test"
            v-model="videoSelected"
            style="float: right; width: 113px; height: 22px"
          />
        </CCardHeader>
        <CCardBody v-if="videohide">
          <!-- <span style="color: red">Please upload .gif file</span><br /> -->
          <div>
            <div>
              <input type="file" @change="previewImage" accept="image/*" />
            </div>
            <div>
              <p>
                Progress: {{ uploadValue.toFixed() + "%" }}
                <progress
                  id="progress"
                  :value="uploadValue"
                  max="100"
                ></progress>
              </p>

              <CButton color="success" @click="onUpload()" v-if="uploadbtn"
                >Upload</CButton
              >
            </div>
          </div>
          <div v-if="imageData != null">
             <video
              v-if="videoplayeron"
                      width="450"
                      height="300"
                      class="preview"
                      controls
                      :src="picture"
                      style="
                        
                       
                      "
                    ></video>
            <img
             v-else 
              class="preview"
              :src="picture"
              style="width: 300px; height: 300px"
            />

               
            <br />
          </div>
        </CCardBody>
      </CCard> </CCol
    >
    <br />
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="3"><h5>Choose Message Type</h5> </CCol>
            <CCol sm="3">
              <input
                type="radio"
                style="width: 57px; height: 21px"
                v-model="imgset"
                value="imgset"
              />&nbsp;<span style="font-size: 17px; font-weight: 500"
                >Token Message
              </span>
            </CCol>
            <CCol sm="6">
              <input
                type="radio"
               v-model="imgset"
                value="imgsetlink"
                style="width: 57px; height: 21px"
              />&nbsp;<span style="font-size: 17px; font-weight: 500"
                >Token Message with Link</span
              >
            </CCol>
          </CRow>
        </CCardHeader>
      </CCard>
    </CCol>
    <!-- <div v-if="messageset"> -->
      <CRow v-if="messageset">
      <CCol sm="6">
        <span style="font-size: 14px">Token hunt message </span>

        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Message 1"
            :maxlength="max"
            v-model="token.msg1"
          />
          <div
            class="input-group-addon inputlength"
            v-text="max - token.msg1.length"
          ></div>
        </div> </CCol
      ><br />
      <CCol sm="6">
        <br />
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Message 2"
            :maxlength="max"
            v-model="token.msg2"
          />
          <div
            class="input-group-addon inputlength"
            v-text="max2 - token.msg2.length"
          ></div>
        </div> </CCol
      ><br />
      <CCol sm="6">
        <br />
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Message 3"
            :maxlength="max3"
            v-model="token.msg3"
          />
          <div
            class="input-group-addon inputlength"
            v-text="max3 - token.msg3.length"
          ></div>
        </div> </CCol
      ><br />
      <CCol sm="6">
        <br />
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Message 4"
            :maxlength="max4"
            v-model="token.msg4"
          />
          <div
            class="input-group-addon inputlength"
            v-text="max4 - token.msg4.length"
          ></div>
        </div> </CCol
      ><br />
      <CCol sm="6">
        <br />
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Message 5"
            :maxlength="max5"
            v-model="token.msg5"
          />
          <div
            class="input-group-addon inputlength"
            v-text="max5 - token.msg5.length"
          ></div>
        </div> </CCol
      ><br />
      <CCol sm="6">
        <br />
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Message 6"
            :maxlength="max6"
            v-model="token.msg6"
          />
          <div
            class="input-group-addon inputlength"
            v-text="max6 - token.msg6.length"
          ></div>
        </div>
      </CCol>
        </CRow>
    <!-- </div> -->
    <br />
    <CCol sm="12" v-if="messagesetlink">
      <br />
      <span style="font-size: 14px">Token Message with link</span>
      <br />

      <br />

      <div
        class="form-group"
        v-for="(input, k) in this.token.messagelink"
        :key="k"
      >
        <CRow>
          <CCol sm="6">
            <input
              type="text"
              class="form-control"
              v-model="input.tokenmessage"
              placeholder="Message"
            />
          </CCol>
          <CCol sm="4">
            <input
              type="text"
                placeholder="Message Link"
              class="form-control"
              v-model="input.tokenmessagelink"
            />
          </CCol>
          <CCol sm="2">
            <span>
              <CButton
                color="danger"
                @click="remove1(k)"
                v-show="k || (!k && token.messagelink.length > 1)"
              >
                <i class="fa fa-times"></i></CButton
              >&nbsp;&nbsp;&nbsp;
              <CButton
                color="success"
                @click="add1(k)"
                v-show="k == token.messagelink.length - 1"
              >
                <i class="fa fa-plus" aria-hidden="true"></i
              ></CButton>
            </span>
          </CCol>
        </CRow>
      </div>
    </CCol>


        <CCol sm="12" >
      <br />
      <span style="font-size: 14px"><b>Token Rage with Token Limit</b></span>
      <br />

      <br />

      <div
        class="form-group"
        v-for="(input, k) in this.token.tokencircle"
        :key="k"
      >
        <CRow>
          <CCol sm="6">
            <input
              type="number"
              class="form-control"
              placeholder="Token Rage"
              v-model.number="input.tokenrage"
              
            />
          </CCol>
          <CCol sm="4">
            <input
              type="number"
              class="form-control"
               placeholder="Token limit"
              v-model.number="input.tokenlimit"
            />
          </CCol>
          <CCol sm="2">
            <span>
              <CButton
                color="danger"
                @click="remove2(k)"
                v-show="k || (!k && token.tokencircle.length > 1)"
              >
                <i class="fa fa-times"></i></CButton
              >&nbsp;&nbsp;&nbsp;
              <CButton
                color="success"
                @click="add2(k)"
                v-show="k == token.tokencircle.length - 1"
              >
                <i class="fa fa-plus" aria-hidden="true"></i
              ></CButton>
            </span>
          </CCol>
        </CRow>
      </div>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from "vue-multiselect";
import { Vselect } from "@/components";
import "vue-select/dist/vue-select.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { APIService } from "../../apiservice.js";
import Papa from "papaparse";
import Embed from "v-video-embed";
import Swal from "sweetalert2";
import firebase from "firebase";
const db = firebase.firestore();
const today = new Date();

export default {
  name: "advanced-forms",
  components: {
    Multiselect,
    Vselect,
    Embed,
  },
  data() {
    return {
      imgset: "",
      imgsetlink: "",
      messageset: false,
      messagesetlink: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
      uploadbtn: false,
      countrymodel: "",
      partcon: false,
      allcon: false,
      showAlert: false,
      dismissSecs: 3,
      dismissCountDown: 3,
      max: 60,
      max2: 60,
      max3: 60,
      max4: 60,
      max5: 60,
      max6: 60,
      videotype: [".mp4"],
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      labelTxt: {
        labelOn: "yes",
        labelOff: "no",
      },
      companyCountry: [],
      state: [],
      city: [],
      countryInfo: [],
      stateInfo: [],
      cityInfo: [],
      videoplayer: false,
      whitehide: false,
      videohide: false,
      csvSelected: false,
      videoSelected: false,
      countrySelected: false,
      AllSelected: false,
      token: {
        allCountry: false,
        particularCountry: false,
        supply: "",
        country: [
          {
            name: "",
            tokenAmount: "",
          },
        ],
        messagelink: [
          {
            tokenmessage: "",
            tokenmessagelink: "",
          },
          
        ],
         tokencircle: [
          {
            tokenrage: 0,
            tokenlimit: 0,
          },
         ],
        istokenmsg:false,
        istokenmsglink:false,
        companyState: "",
        companyCity: "",
        location: [],
        csvdata: [],
        isWhiteList: false,
        videoupload: "",
        isVideoselected: false,
        msg1: "",
        msg2: "",
        msg3: "",
        msg4: "",
        msg5: "",
        msg6: "",
        message: [],
      },
      date: "",
      phone: "",
      taxid: "",
      ssn: "",
      eye: "",
      ccn: "",
      multi: null,
      csvSelected: null,
      selectedDate: {
        start: new Date(today.getFullYear(), today.getMonth(), 7),
        end: new Date(today.getFullYear(), today.getMonth(), 11),
      },
      value: null,
      options: ["list", "of", "options"],
      multiselectOptions: [
        "shopping_mall",
        "atm",
        "bakery",
        "bank",
        "bar",
        "park",
        "restaurant",
        "stadium",
        "supermarket",
        "subway_station",
      ],

      channel_name: "",
      channel_fields: [],
      channel_entries: [],
      parse_header: [],
      parse_csv: [],
      sortOrders: [],
      sortKey: "",
      selectedFile: "",
      videoplayeron:false
    };
  },
  watch: {
    imgset() {
      console.log("imgset", this.imgset);
      if (this.imgset == "imgset") {
            this.messageset=true;
            this.messagesetlink=false;
            this.token.istokenmsg=true;
            // this.istokenmsglink=false;
      }else if(this.imgset == "imgsetlink"){
               this.messagesetlink=true;
               this.messageset=false;
              //  this.istokenmsg=false;
           this.token.istokenmsglink=true;
      }
    },
  
    countrymodel() {
      // console.log("data", this.countrymodel);
      if (this.countrymodel == "allcountry") {
        this.allcon = true;
        this.partcon = false;
        this.token.allCountry = true;
      } else if (this.countrymodel == "particularcountry") {
        this.partcon = true;
        this.allcon = false;
        this.token.particularCountry = true;
      }
    },
    csvSelected() {
      // console.log("entered", this.csvSelected);

      if (this.csvSelected == true) {
        this.whitehide = true;
      } else if (this.csvSelected == false) {
        this.whitehide = false;
      }
    },
    videoSelected() {
      if (this.videoSelected == true) {
        this.videohide = true;
      } else if (this.videoSelected == false) {
        this.videohide = false;
      }
    },
    "token.companyCountry"() {
      let temp = this.countryInfo.filter((n) => {
        return n.name == this.token.companyCountry;
      });
      let data = { cid: temp[0].id };
      this.state = [];
      this.token.companyState = "";
      this.city = [];
      this.token.companyCity = "";
      APIService.getState(data).then((res) => {
        if (res.status == 200) {
          // console.log("res data is state", res.data);
          this.stateInfo = res.data;
          for (let i in this.stateInfo) {
            this.state.push(this.stateInfo[i].name);
          }
        }
      });
    },
    "token.companyState"() {
      let temp = this.stateInfo.filter((n) => {
        return n.name == this.token.companyState;
      });
      let data = { city: temp[0].id };
      this.city = [];
      this.token.companyCity = "";
      APIService.getCity(data).then((res) => {
        if (res.status == 200) {
          // console.log("res city", res.data);
          this.cityInfo = res.data;
          for (let i in this.cityInfo) {
            this.city.push(this.cityInfo[i].name);
          }
        }
      });
    },
  },
  methods: {
    add() {
      this.token.country.push({
        name: "",
        tokenAmount: "",
      });
      console.log(this.token.country);
    },

    remove(index) {
      this.token.country.splice(index, 1);
    },
    add1() {
      this.token.messagelink.push({
        tokenmessage: "",
        tokenmessagelink: "",
      });
      console.log("messagelink", this.token.messagelink);
    },

    remove1(index) {
      this.token.messagelink.splice(index, 1);
    },
      add2() {
      this.token.tokencircle.push({
        tokenrage: "",
        tokenlimit: "",
      });
      console.log("tokencircle", this.token.tokencircle);
    },

    remove2(index) {
      this.token.tokencircle.splice(index, 1);
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      // if(this.imageData.length>0){
      this.uploadbtn = true;
      // }
    },

    onUpload() {
      this.picture = null;
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      var fileextension = this.imageData.name.split(".")[1];
      if(fileextension=="mp4"){
        this.videoplayeron=true
      }else{
        this.videoplayeron=false
      }
      const storageRef = firebase
        .storage()
        .ref(`tokenImages/${random_number}.${fileextension}`)
        .put(this.imageData);
      storageRef.on(
        `state_changed`,
        (snapshot) => {
          this.uploadValue =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            console.log("url5", url);
            this.picture = url;
            this.token.videoupload = url;
            if (this.token.videoupload.length > 0) {
              this.token.isVideoselected = true;
            }
            if (this.picture.length > 0) {
              this.uploadbtn = false;
            }
          });
        }
      );
    },
    validate() {
      //  this.$root.$emit("pass1", this.token);
      // this.$root.$emit("passdone", this.token,this.country);
      //  return true;
      if (this.countrymodel == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please choose All country or Particular country",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.country == "" || this.token.supply == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please enter country details",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.location == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please choose Loaction",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (this.token.videoupload == "") {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Please upload gif ",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        this.$root.$emit("passdone", this.token, this.country);
        return true;
      }
    },

    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    onFileChange(e) {
      const selectedFile = e.target.files[0]; // accessing file
      this.selectedFile = selectedFile;
    },
    // onUploadFile() {
    //   const formData = new FormData();
    //   formData.append("file", this.selectedFile);
    //    console.log("this.selectedFile",this.selectedFile)
    // },
    onUploadFile() {
      let self = this;
      let data = new FormData();
      data.append("file", this.selectedFile);
      // if (this.selectedFile.type.match(/.(gif)$/i)) {
      // console.log("entered");
      APIService.uploadvideo(data).then(
        (res) => {
          if (res.status == 200) {
            this.token.videoupload = res.data.location;
            this.videoplayer = true;
            if (this.token.videoupload.length > 0) {
              this.token.isVideoselected = true;
            }
            this.selectedFile = false;

            // console.log("user info heree", this.token);

            this.$notify({
              timeout: 1000,
              message: "Company logo uploaded successfully.",
              icon: "add_alert",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "success",
            });
          } else {
            Swal("Oops...", "Something went wrong!", "error");
          }
        },
        (err) => {
          self.errMsg = "Cannot upload Profile Image2";
        }
      );
      // }
      // else {
      //   // console.log("Oops...", "Something went wrong!", "error");
      //   Swal.fire({
      //     position: "center",
      //     icon: "error",
      //     title: "Wrong format please upload .gif ",
      //     showConfirmButton: false,
      //     timer: 2000,
      //   });
      // }
    },
    upload(e) {
      const that = this;
      let fname = event.target.files[0].name.split(".");
      if (fname[1].toLowerCase() == "csv") {
        const fileToLoad = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (fileLoadedEvent) => {
          Papa.parse(fileLoadedEvent.target.result, {
            header: true,
            complete(results) {
              that.token.csvdata = [];

              for (let i = 0; i < results.data.length - 1; i++) {
                that.token.csvdata.push(results.data[i].address);

                if (that.token.csvdata.length > 0) {
                  that.token.isWhiteList = true;
                  that.showAlert = true;
                }

                console.log("this.token.csvdata", that.token.csvdata);
              }
              that.doc = JSON.stringify(results.data, null, 2);
              that.$emit("result", results.data);
            },
            error(errors) {
              // console.log("error", errors);
            },
          });
        };
        reader.readAsText(fileToLoad);
      } else {
        document.getElementById("fileInput").value = "";
      }
    },
    nextTab() {
      // console.log("tabbutton form2");
      this.$emit("pass2", this.token, this.country);
    },

    getCountry() {
      // console.log("data");
      APIService.getAllCountry().then((res) => {
        if (res.status == 200) {
          // console.log("res.data", res.data);
          this.countryInfo = res.data;
          for (let i in this.countryInfo) {
            this.companyCountry.push(res.data[i].name);
          }
        } else {
          // console.log("else", res);
        }
      });
    },
    wizard() {
      this.$router.push({ name: "wizard" });
    },
  },
  created: function () {
    this.getCountry();
  },
};
</script>
<style scoped>
.inputlength {
  background: darkgrey;
  font-size: large;
  width: 33px;
  text-align: center;
  font-weight: 500;
}
</style>
